import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.2,
  beforeSend(event) {
    if (event.breadcrumbs) {
      event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {
        if (breadcrumb.category === 'fetch' && breadcrumb.data) {
          const data = { ...breadcrumb.data };
          delete data['x-token-auth'];
          return { ...breadcrumb, data };
        }
        return breadcrumb;
      });
    }
    return event;
  },
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data) {
      const data = { ...breadcrumb.data };
      delete data['x-token-auth'];
      return { ...breadcrumb, data };
    }
    return breadcrumb;
  },
});

export { Sentry };
